import React, { useEffect, useState, useRef } from "react";


/* { items, currentIndex, setCurrentIndex, selectedCorrectAnswer } */
function MixNMatchSection ({items, currentSelection, setCurrentSelection, setActiveState, selectedRightAnswer})
{
  const numberOfItems = useRef(5);
  const [itemHeight] = useState(100);
  const [itemGap] = useState(1);
  const [bigItemGap] = useState(30);
  const [stripHeight, setStripHeight] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [pos, setPos] = useState(0);
  const [itemPosArray, setItemPosArray] = useState(Array(numberOfItems));
  const dragRef = useRef();
  
  useEffect(() => {
    if(items.length > 0){
      numberOfItems.current = items.length;
      calculateItemPos();
      setStripHeight(calculateStripHeight());
      let initPosition = 0;
      if (numberOfItems.current % 2) {
        initPosition = Math.floor(numberOfItems.current / 2);
      } else {
        initPosition = Math.floor(numberOfItems.current / 2) - 1;
      }
      moveStripToSelection(initPosition);
    }
  }, [items]);
  
  // --> INITIAL PLACEMENT OF THE ELEMENTS
  useEffect(() => {
    calculateItemPos();
    setStripHeight(calculateStripHeight());
    let initPosition = 0;
    if (numberOfItems.current % 2) {
      initPosition = Math.floor(numberOfItems.current / 2);
    } else {
      initPosition = Math.floor(numberOfItems.current / 2) - 1;
    }
    moveStripToSelection(initPosition)
  }, []);

  // --> EVENTS
  // Down events
  const mouseDownEvent = (e) => {
    setDragging(true);
    dragRef.current = e.clientY - pos;
    setActiveState(true);
  }
  const touchDownEvent = (e) => {
    setDragging(true);
    dragRef.current = e.touches[0].clientY - pos;
    setActiveState(true);
  }
  // Move events
  const mouseMoveEvent = (e) => {
    if (dragging) {
      moveStrip(calculateMovement(e.clientY));
    }
  }
  const touchMoveEvent = (e) => {
    if (dragging) {
      moveStrip(calculateMovement(e.touches[0].clientY));
    }
  }
  // Up events 
  const mouseUpEvent = (e) => {
    setDragging(false);
    snapStrip();
  }
  const touchUpEvent = (e) => {
    setDragging(false);
    snapStrip();
  }

  // Item click event
  const itemClicked = (itemIndex, e) => {
    /*
    if (dragging) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      moveStripToSelection(itemIndex);
    }*/
  }

  // --> STRIP PLACEMENT & UPDATES
  const moveStrip = (newPos) => {
    setPos(newPos);
    let newSelection = calculateSelection(newPos);
    if (newSelection !== currentSelection) {
      setCurrentSelection(newSelection);
    }
  }

  useEffect(() => {
    calculateItemPos();
    if (!dragging) {
      moveStripToSelection(currentSelection);
    }
  }, [currentSelection, dragging]);

  const moveStripToSelection = (selection) => {
    let newPos = (selection * (itemHeight + itemGap)) * -1;
    moveStrip(newPos);
  }

  const snapStrip = () => {
    moveStripToSelection(currentSelection);
  }

  const calculateSelection = (refPos) => {
    let newSelection = (Math.floor((refPos - (itemHeight / 2)) / (itemHeight + itemGap)) * -1) - 1;
    if (newSelection >= numberOfItems.current) {
      newSelection = numberOfItems.current - 1;
    } else if (newSelection < 0) {
      newSelection = 0;
    }
    return newSelection;
  }

  const calculateMovement = (pointerY) => {
    const sectionHeight = ((numberOfItems.current - 1) * itemHeight) + ((numberOfItems.current - 1) * itemGap);
    let newPos = pointerY - dragRef.current;
    if (newPos > 0) {
      newPos = newPos / 3;
    } else if (newPos < sectionHeight * -1) {
      //newPos = sectionHeight * -1; TODO!! add bottom rubber band fx
    }
    return newPos;
  }

  const calculateItemPos = () => {
    let newPos = 0;
    let extraOffset = 0;
    let newPosArray = [...itemPosArray];
    for (let i = 0; i < numberOfItems.current; i++) {
      if (i < currentSelection) {
        extraOffset = 0;
      } else if (i === currentSelection) {
        extraOffset = bigItemGap;
      } else if (i > currentSelection) {
        extraOffset = bigItemGap * 2;
      }
      newPos = ((itemHeight * i) + (itemGap * i) + extraOffset);
      newPosArray[i] = newPos;
    }
    setItemPosArray(newPosArray);
  }

  const calculateStripHeight = () => {
    let newStripHeight;
    newStripHeight = (numberOfItems.current * itemHeight) + (numberOfItems.current * itemGap) + (2 * bigItemGap);
    return newStripHeight;
  }

  return (
    <div className={`mix-n-match-section ${selectedRightAnswer ? 'animOut' : ''}`}
      onMouseDown={mouseDownEvent}
      onTouchStart={touchDownEvent}
      onMouseMove={mouseMoveEvent}
      onTouchMove={touchMoveEvent}
      onMouseUp={mouseUpEvent}
      onTouchEnd={touchUpEvent}
      onMouseLeave={mouseUpEvent}
    >
      <div className="section-item-container">
        <div
          className="section-items-wrapper"
          style={{
            transform: `translate3d(0, ${(itemHeight / 2 + bigItemGap) * -1}px, 0)`
          }}>
          <div
            className={`section-items-anchor ${dragging ? 'dragging' : ''}`}
            style={{
              transform: `translateY(${pos}px)`,
              height: `${stripHeight}px`
            }}>
            {[...Array(numberOfItems.current)].map((e, i) => (
              <div
                key={i}
                className={`section-item ${currentSelection === i ? 'current' : ''}`}
                style={{
                  height: `${itemHeight}px`,
                  transform: `translate3d(0, ${itemPosArray[i]}px, 0)`
                }}
                onClick={(e) => itemClicked(i, e)}
              >
                <div
                  className="section-item-image-wrapper"
                  style={{
                    backgroundImage: `url(${items[i]?.image})`
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>
        <div
          className="indicator-overlay"
          style={{
            top: `${((itemHeight + (bigItemGap * 2)) / 2) * -1}px`,
            height: `${itemHeight + (bigItemGap * 2)}px`
          }}
        ></div>
      </div>
    </div>
  );  
}

export default MixNMatchSection;